import { useState } from 'react';
import toast from 'react-hot-toast';

import Select from 'react-select';
import ButtonLoader from './ButtonLoader';

import useLicenseTypes from '../hooks/useLicenseTypes';

const AddRequiredLicenseForm = ({ disabledLicenses = [], onSubmit, isSubmitting, onCloseClicked }) => {
  const [selectedLicenses, setSelectedLicenses] = useState(null);

  const { data, isLoading } = useLicenseTypes({ page: 1, perPage: 100 });

  const licenseTypes = data?.licenseTypes
    .filter(licenseType => !disabledLicenses.find(dl => dl.hrwlCode === licenseType.hrwlCode))
    .map(licenseType => ({
      value: licenseType._id,
      label: `${licenseType.hrwlCode} - ${licenseType.name}`
    }));

  const handleSubmit = e => {
    e.preventDefault();

    if (!selectedLicenses) {
      toast.error('Please select a license');
      return;
    }

    onSubmit(selectedLicenses.map(l => l.value));
  }

  return (
    <div className="bg-white rounded-lg shadow-md shadow-ase-blue w-full md:w-[600px]">
      <div className="flex items-center justify-between text-lg border-b bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Add Licenses</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 py-2 px-4"
      >
        <label className='flex flex-col gap-1'>
          <span>Type</span>

          <Select
            value={selectedLicenses}
            onChange={setSelectedLicenses}
            options={licenseTypes}
            isMulti={true}
            isLoading={isLoading}
            isDisabled={isLoading}
          />
        </label>

        <button
          type="submit"
          className="w-full bg-ase-blue text-white font-semibold h-[48px] rounded-md flex items-center justify-center"
        >
          {isSubmitting ? <ButtonLoader /> : 'Add'}
        </button>
      </form>
    </div>
  )
}

export default AddRequiredLicenseForm;
